<template>
  <b-container>
    <b-row class="ja-decoration">
    </b-row>
    <b-form @submit.prevent="changePassword()">
      <b-row>
        <b-col cols="12">
          <b-col cols="12" class="mt-1 title" v-html="$t('change_password_title')"></b-col>
        </b-col>
        <b-col cols="12">
          <b-col cols="12 mt-4">
            <label for="password" class="label-text">{{ $t('change_password_current_pass') }}</label>
            <input id="password" type="password" v-model="form.currentPassword" value="">
            <span v-if="currentPasswordError" class="form-error">{{ $t("error_required_field") }}</span>
            <ul class="mt-2 error-content">
              <li class="error-text" v-for="error in currentPasswordErrors" v-bind:key="error">{{  error }}</li>
            </ul>
          </b-col>
        </b-col>
        <b-col cols="12">
          <b-col cols="12 mt-4">
            <label for="new-password" class="label-text">{{ $t("reset_new_password") }}</label>
            <input id="new-password" type="password" v-model="form.password" value="">
            <span v-if="passwordError" class="form-error">{{ $t("error_required_field") }}</span>
            <ul class="mt-2 error-content">
              <li class="error-text" v-for="error in passwordErrors" v-bind:key="error">{{ error }}</li>
            </ul>
          </b-col>
        </b-col>
        <b-col cols="12">
          <b-col cols="12 mt-4">
            <label for="confirm-password" class="label-text">{{ $t('register_confirm_password') }}</label>
            <input id="confirm-password" type="password" v-model="form.confirmPassword" value="">
            <span v-if="confirmPasswordError" class="form-error">{{ confirmPasswordError }}</span>
          </b-col>
        </b-col>
        <b-col cols="12">
          <b-col cols="12" class="mt-5">
            <b-button block variant="primary" type="submit">{{ $t('change_password_btn') }}</b-button>
          </b-col>
          <b-col cols="12" class="mt-3 mb-4">
            <b-button block variant="primary-inverse" @click="cancel()">{{ $t('button_cancel') }}</b-button>
          </b-col>
        </b-col>
      </b-row>
    </b-form>
    <legal-message/>
  </b-container>
</template>

<script>
import { UserService } from '../Services';
import LegalMessage from "../Components/LegalMessage"

export default {
  name: 'ChangePassword',
  components: { LegalMessage },
  data(){
    return {
      form: { currentPassword: "", password: "", confirmPassword: "" },
      currentPasswordError: false,
      passwordError: false,
      confirmPasswordError: "",
      currentPasswordErrors: [],
      passwordErrors: [],
      serviceError: false
    }
  },
  methods: {
    changePassword(){
      const form = this.form;
      const currentPassword = form.currentPassword;
      const password = form.password;
      const confirmPassword = form.confirmPassword;
      this.currentPasswordError = currentPassword === "";
      this.passwordError = password === "";
      this.confirmPasswordError = ""

      if(confirmPassword === "") this.confirmPasswordError = this.$t("error_required_field");
      if(password !== confirmPassword) this.confirmPasswordError =  this.$t('error_confirm_password_not_coincide');
      if(confirmPassword !== "" && password === confirmPassword) this.confirmPasswordError =  "";

      if(currentPassword && password && confirmPassword && password === confirmPassword) {
        this.passwordErrors = []
        this.currentPasswordErrors = []
        this.serviceError = false

        UserService.changeUserPassword(form).then(() => {
          this.$router.go(-1)
        }).catch(err => {
          this.serviceError = this.$t("error_unexpected")
          if (err) {
            if (err.message) {
              this.serviceError = err.message
            }
            if (err.errors && err.errors['Password']) {
              err.errors['Password'].forEach(error => this.passwordErrors.push(this.$t(error)))
            }
            if (err.errors && err.errors['CurrentPassword']) {
              this.currentPasswordErrors.push(this.$t('error_incorrect_password'))
            }
          }
        })
      }
    },
    cancel(){
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped lang="stylus">

@import "../Styles/security_styles.styl"

.last-updated
  font-family arial, sans-serif
  font-size 12px
  font-weight bold
  font-style italic
  color black

.label-text
  color #5E4FB2
</style>
